import { useEffect, useState } from 'react';

function useDebounce<T>(value: T, delay: number) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const [isDebouncing, setIsDebouncing] = useState(false);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
            setIsDebouncing(false);
        }, delay);

        return () => {
            setIsDebouncing(true);
            clearTimeout(handler);
        };
    }, [value, delay]);

    return { debouncedValue, isDebouncing };
}

export default useDebounce;
